import i18n from '@/lang/'
//import _moneyHelper from '@/../static/js/common/common'

let autopayRegulation = {payAgreeSymbol_wrap : false };
// let commonHelper = _moneyHelper();
// autopayRegulation.globalPriceFormat(item.currencyType, price)

// 渲染/mo*************
let moOrDay = function(data){

	var str = "";
	if(data.periodUnit == 1){
	if(data.period>1){
		str = data.period+i18n.t('packages.periodUnits.day');
	}else{
		str = i18n.t('packages.periodUnit.day');
	}

	}else if(data.periodUnit == 2 || data.periodUnit == 12){
		if(data.period>1){
			str = data.period+i18n.t('packages.periodUnitsSimp.month');
		}else{
			str = i18n.t('packages.periodUnitSimp.month');
		}
	}else if(data.periodUnit == 0){
		if(data.period>1){
			str = data.period+i18n.t('packages.periodUnits.hour');
		}else{
			str = i18n.t('packages.periodUnit.hour');
		}
	}else if(data.periodUnit == 3){
		if(data.period>1){
			str = data.period+i18n.t('packages.periodUnits.year');
		}else{
			str = i18n.t('packages.periodUnit.year');
		}
	}else{
		str = '';
	}
	return str;

};

/*
	_AllRechargeCreateOrderAjax 连续下单方法
	依赖之前支付订单步骤直接下单
*/
let _AllRechargeCreateOrderAjax = function(payMethod){
	let payAgreeFlag = 1;
	autopayRegulation.createOrder(payMethod , payAgreeFlag);
};

//检测是否订购过连续畅享
/*
*** streamNo
*** partnerCode
*** loginCustomerId	
*** imei
*/
let checkUserCanNotCreateOrderAjax = function(){
	let _queryAgreementParam = {
		// loginCustomerId:localStorage.getItem('loginCustomerId'),
		imei:autopayRegulation.currentIMEI_imei,
	}
	
	return  autopayRegulation.getDataAjax(
		autopayRegulation.$api.queryAgreement,
		_queryAgreementParam).then( rs => {return [rs.data.payAgreements && rs.data.payAgreements.length ,rs.data.payAgreements]} , error =>{
			return false;
		});
}

/*
	*PayMethodPromise 购买或者提示----检测是否签约过套餐后处理动作
	* @param data  原始页面传递所有数据
	* @param payMethod 在线支付还是余额支付
*/
let PayMethodPromise = function(payMethod){
	checkUserCanNotCreateOrderAjax().then(function( [buyRecharge ,_payAgreements] ){

		if(!buyRecharge){
			_AllRechargeCreateOrderAjax(payMethod);
		}else{
			let  AlreadyPurchasedTips = i18n.t("orderTips.AlreadyPurchased").replace('%@',_payAgreements[0].goodsName);
			autopayRegulation.$showDialog({
				title:i18n.t('flowDetail.tip'),
			    message: AlreadyPurchasedTips,
			    // confirmButtonText: i18n.t('settlement_confirm')
			}).then(() => {
			  // on close
			});
		}
	},function(rs){
		let  AlreadyPurchasedTips = i18n.t("orderTips.AlreadyPurchased").replace('%@',_payAgreements[0].goodsName);
		autopayRegulation.$showDialog({
			title:i18n.t('flowDetail.tip'),
		    message: AlreadyPurchasedTips,
		});
	})
	
}

//一条龙创建订单
let RechargePaymentForCreateOrder = function(payMethod){
	let currentPayMethod= payMethod.typeMethod;
	PayMethodPromise(currentPayMethod);
}

let _CheckPaymethodFn = function(typeMethod){
	if(typeMethod == 'ACCOUNT_AMOUNT'){
		ACCOUNT_AMOUNT.init();
	}else if(typeMethod == 'PAYONLINE'){
		_OnlineBuy.init();
	}
}

//余额连续畅享
let ACCOUNT_AMOUNT ={
	typeMethod:'ACCOUNT_AMOUNT',
	//创建订单
	init:function(){
		RechargePaymentForCreateOrder(ACCOUNT_AMOUNT)
	}
}


//在线支付
let _OnlineBuy = {
	typeMethod:'PAYONLINE',
	payFunction:'PAY',
	init:function(_CurrentMsgOnlyUseForCreateOrder){
		_OnlineBuy.payFunction = 'CYCLE';
		RechargePaymentForCreateOrder(_OnlineBuy)
	},
	pay:function(options) {
		let clientDesc = "glocalme_wap";
		let channelCode = staticData.website.config.autopayRegulation.payChannelCode;
		// autopayRegulation.cookieHelper.set("loginCustomerId", options.loginCustomerId, {expires: 1, domain: "." + location.hostname});;
		let _bizContent = {
		        	deductAmount:options.deductAmount||'',
			        deductFirstTime:options.deductFirstTime||'',
			        deductPeriodNumber:options.deductPeriodNumber||'',
			        deductPeriodUnit:options.deductPeriodUnit||'',
			        bcWapUrl:'m.glocalme.com',
			        bcWapName:'Glocalme WEB',	
		    }
		    _bizContent = JSON.stringify(_bizContent);

		// 通过中台接口获取收银台链接，然后去收银台支付
		autopayRegulation.getDataAjax(
	    	autopayRegulation.$api.data_package.createOnlineorder,
		    { 
		    	mvnoCode:options.mvnoCode,
		    	orgCode:options.orgCode,
		    	loginCustomerId:options.loginCustomerId,                       
		        orderSn: options.orderSn,
		        orderSubject: options.orderSubject,
		        orderDesc: options.orderDesc,
		        returnUrl:options.returnUrl,
		        timeStamp: options.timeStamp,
		        totalAmount: options.totalAmount,
		        currencyCode: options.currencyCode,
		        payFunction: _OnlineBuy.payFunction,
		        clientDesc:clientDesc,
		        channelCode:channelCode,  
		        bizContent:_bizContent,
		}).then( res =>{
	        if(res.cashierUrl) {
	            let localeCode = autopayRegulation.langType;
				// if(localeCode === 'in-ID') localeCode = 'id-ID';
	            //默认PC模板
	            let clientMode = 'WAP';
	            let payUrl = `${res.cashierUrl}&clientMode=${clientMode}&localeCode=${localeCode.split('-').join('_')}`;
	            location.href = payUrl;
	        }
		}).catch(e =>{
			autopayRegulation.$showDialog({
				title:i18n.t('flowDetail.tip'),
			    message: e.resultDesc,
			    buttonText: i18n.t('settlement_confirm')
			});
		})
	}
}

autopayRegulation.goToLxcxPkg = function(){
	let _data_infoForCurrentPage = JSON.parse(sessionStorage.data_info);
	_data_infoForCurrentPage.isLxcx = true;
	let key_Array = Object.keys(_data_infoForCurrentPage.data).filter((i)=> i!=_data_infoForCurrentPage.selectPackage )
	_data_infoForCurrentPage.selectPackage = key_Array[0];
	sessionStorage.data_info = JSON.stringify(_data_infoForCurrentPage)
	 window.location.reload();
}

//文案-金额处理
let saveMoney= function(sale_Promotion_word ,data ,thisIsGeneralPackageHasLxcx ,Contract_recommendation_word){
	if(!data.currencyType){
		data.currencyType = data.sourceCurrency
	}

	let periodTxt = data.periodUnit == 'MONTH' ? i18n.t("orderTips.iMonths") : i18n.t("orderTips.iDays") ;
	
	if( data.deductionInfo && (data.deductionInfo.autoRenewPrice || data.deductionInfo.autoRenewFirstPrice )){
  		let CaculatorSaveMoney = parseInt(data.goodsPrice) - parseInt(data.deductionInfo.autoRenewPrice);
    			CaculatorSaveMoney = autopayRegulation.globalPriceFormat(data.currencyType , CaculatorSaveMoney);	
  		try{
  			//首月折扣，每月净省
  			sale_Promotion_word = sale_Promotion_word.replace('%@money',autopayRegulation.globalPriceFormat(data.currencyType,data.deductionInfo.autoRenewPrice));
  			sale_Promotion_word = sale_Promotion_word.replace('%@firstMoney',autopayRegulation.globalPriceFormat(data.currencyType,data.deductionInfo.autoRenewFirstPrice));
  			sale_Promotion_word = sale_Promotion_word.replace(new RegExp('%@periodSymbol',"g"),data.billingInfos ? moOrDay(data.billingInfos[0]) : '');
  			//折扣包月
  			sale_Promotion_word = sale_Promotion_word.replace('%@saveMoney',CaculatorSaveMoney);
  			sale_Promotion_word = sale_Promotion_word.replace('%@period',data.billingInfos ? moOrDay(data.billingInfos[0]) : '');

  			//签约套餐文案
  			Contract_recommendation_word = Contract_recommendation_word.replace('%@money', autopayRegulation.globalPriceFormat(data.currencyType,data.deductionInfo.autoRenewPrice));
  			Contract_recommendation_word = Contract_recommendation_word.replace('%@firstMoney', autopayRegulation.globalPriceFormat(data.currencyType,data.deductionInfo.autoRenewFirstPrice));
  		}catch(e){
  			console.log('No payAgreeSymbol')
  		}
  	}else if(thisIsGeneralPackageHasLxcx){
		let CaculatorSaveMoney = parseInt(data.goodsPrice) ;
		CaculatorSaveMoney =  autopayRegulation.globalPriceFormat(data.currencyType ,CaculatorSaveMoney);
		//是连续畅享 - 但是没有优惠
		Contract_recommendation_word = Contract_recommendation_word.replace('%@money',CaculatorSaveMoney);
		sale_Promotion_word = sale_Promotion_word.replace('%@money',CaculatorSaveMoney);
		
	}
	if(!thisIsGeneralPackageHasLxcx){
		//更换文案
		autopayRegulation.sale_Promotion = sale_Promotion_word;
		//签约套餐显示文案
		autopayRegulation.payAgreeSymbol_wrap = true;
		autopayRegulation.GeneralPackageHasLxcx_show = false;
		
	}else{
		
		//普通包月含有签约推荐
		autopayRegulation.Contract_recommendation = Contract_recommendation_word;	
		autopayRegulation.GeneralPackageHasLxcx_show = true;
		autopayRegulation.payAgreeSymbol_wrap = false;
		//console.log(autopayRegulation.GeneralPackageHasLxcx_show);
	}
}

//文案处理
let sale_PromotionInit = function(data , thisIsGeneralPackageHasLxcx){
	let sale_Promotion_word = i18n.t('orderTips.Ordinary_monthly_package');
	let Contract_recommendation_word = i18n.t('orderTips.Contract_recommendation_General');
	if(data.deductionInfo){
		if( data.deductionInfo.autoRenewFirstPrice && data.deductionInfo.autoRenewPrice > data.deductionInfo.autoRenewFirstPrice ){
			//首月折扣，每月净省
			sale_Promotion_word = i18n.t('orderTips.First_charge_discount');
			Contract_recommendation_word = i18n.t('orderTips.Contract_recommendation_First');
							
		}else if(data.deductionInfo.autoRenewPrice && data.goodsPrice > data.deductionInfo.autoRenewPrice ){
			//折扣包月
			sale_Promotion_word = i18n.t('orderTips.Monthly_discount');
			Contract_recommendation_word = i18n.t('orderTips.Contract_recommendation_Monthly_discount');
		}else{
			//普通包月
			sale_Promotion_word = i18n.t('orderTips.Ordinary_monthly_package');
			Contract_recommendation_word = i18n.t('orderTips.Contract_recommendation_General');
		}
	}else{
		sale_Promotion_word = i18n.t('orderTips.Ordinary_monthly_package');
		Contract_recommendation_word = i18n.t('orderTips.Contract_recommendation_General');
	}
	//文案-金额处理
	saveMoney(sale_Promotion_word , data , thisIsGeneralPackageHasLxcx, Contract_recommendation_word);
}

//确定连续包月绑定方法
function checkButtonnBind(status){
	autopayRegulation.CurrentPackageStatusISLXCX = status;
}

//界面展示变化
let showPayAgreeSymbol_wrap = function(data){
	//预计算
	let  payAgreeFlagObject = {};
	//payAgreeFlagObject.actCode = data.deductionInfo.autoRenewActCode;
	payAgreeFlagObject.payAgreeFlag = 1;
	// debugger;
	autopayRegulation.e_preCalcOrder(payAgreeFlagObject);
	//显示文案
	sale_PromotionInit(data);
	//确定连续包月绑定方法
	checkButtonnBind(true);
}

//显示关联套餐
let GeneralPackageHasLxcx = function(data){
	//文案处理
	sale_PromotionInit(data ,true);
}

/*
**	showGeneralPackage ----展示普通流量包
**	@param  status     ----销售品关系-签约推荐-是否有关联普通流量包
*/
let showGeneralPackage = function(status,data){
	if(status){
		//显示关联套餐--
		GeneralPackageHasLxcx(data)
	}
	//确定普通流量包绑定方法
	checkButtonnBind(false);
	_OnlineBuy.payFunction = 'PAY';
}

//判断是否连续畅享
let categoryCode_IS_LXCX  = function(data){
	//是否是连续畅享----用自己的数据判断--上游数据不可信
	if(data.categoryCode=="LXCX" && +data?.attrMap?.payAgreeFlag == 1 ){
		showPayAgreeSymbol_wrap(data);
		
	}else{
		//展示普通流量包
		//是否有关联连续畅享
		try{
			if(sessionStorage.data_info && !JSON.parse(sessionStorage.data_info).isLxcx){
				//展示普通流量包
				let data_info = JSON.parse(sessionStorage.data_info);

				let key_Array = Object.keys(data_info.data).filter((i)=> i!=data_info.selectPackage )
				if(key_Array[0]){
					let isLxcx_data = JSON.parse(data_info.data[key_Array[0]]);
					showGeneralPackage(true,isLxcx_data);	
				}else{
					//普通包需要再次刷新
					showGeneralPackage(true,data);
					autopayRegulation.GeneralPackageHasLxcx_show = false;
				}
				
			}
		}catch(e){
		}
		
		autopayRegulation.payAgreeSymbol_wrap = false;

		
	}
}

//提供方法给外部调用-查询完套餐后判断是否是连续畅享
autopayRegulation.categoryCode_IS_LXCX = function(data){
	//还原接口值
	if(data.oringPrice){
		data.goodsPrice = data.oringPrice;
	}
	categoryCode_IS_LXCX(data);
};

//使用在线支付创建支付订单
autopayRegulation._OnlineBuyPay = function(data){
	_OnlineBuy.pay(data);
}

//连续包月-入口检测-确定是连续包月
autopayRegulation._RechargePaymentAccess = function(_PaymethodForCheck){
	if(_PaymethodForCheck){
		_CheckPaymethodFn(_PaymethodForCheck);
	};
}

autopayRegulation.GeneralPackageHasLxcx_show = false;

export default autopayRegulation;